<template>
  <div>
    <div>
      <p class="title">ДОГОВОР №{{ doc.ID }}</p>
      <p class="subtitle">оказания услуг таможенным представителем</p>
      <div style="display: flex; justify-content: space-between">
        <div>Город {{ doc.bc_city }}</div>
        <div>&laquo;{{ day }}&raquo; {{ month }} {{ year }} г.</div>
      </div>
      <p style="text-align: justify">
        {{ doc.org1.organizations.org_type }} &laquo;{{
          doc.org1.organizations.org_name
        }}&raquo;, зарегистрированное по адресу:
        {{ getOrganizationAddress(doc.org1) }}, именуемое в дальнейшем
        «Продавец» в лице {{ doc.org2.organizations.company_ceo }}, действующего
        на основании Устава, с одной стороны, и
        {{ doc.org2.organizations.org_type }} &laquo;{{
          doc.org2.organizations.org_name
        }}&raquo;, зарегистрированное по адресу:
        {{ getOrganizationAddress(doc.org2) }}, именуемое в дальнейшем
        «Покупатель», в лице {{ doc.org1.organizations.company_ceo }},
        действующего на основании Устава, с другой стороны, далее совместно
        именуемые «Стороны», подписали настоящий Контракт (далее – «Контракт») о
        нижеследующем.
      </p>
      <p class="subtitle">1. Предмет договора</p>
      <p style="text-align: justify">
        1.1. Заказчик поручает и оплачивает, а Таможенный представитель от имени
        и по поручению Заказчика оказывает услуги по совершению таможенных
        операций, связанных с помещением товаров под таможенную процедуру, в
        соответствии с законодательством Таможенного союза и (или) Республики
        Казахстан, а также услуги по предварительным операциям и выполнению
        других посреднических функций в сфере таможенного дела, определенных в
        рамках поданной Заказчиком Заявки (оформленной в письменной или устной
        форме, по желанию Сторон), являющейся, после ее принятия Таможенным
        представителем к исполнению, неотъемлемой частью настоящего Договора.
      </p>
      <p>
        1.2. Помимо услуг, определенных в п.1.1. настоящего Договора, по
        поручению и за счет Заказчика, Таможенный представитель на основании
        поданной Заявки оказывает Заказчику услуги по информированию и
        консультированию в сфере логистики, таможенной очистке товаров,
        изменений таможенного законодательства, а также по иным аналогичным
        вопросам.
      </p>
      <p style="text-align: justify">
        1.3 Таможенный представитель обладает правами на оказание услуг по
        настоящему Договору, вытекающими из {{ doc.bc_agreement }}
      </p>
      <p class="subtitle">2. Права и обязанности Сторон</p>
      <p>
        <strong> 2.1. Заказчик вправе: </strong>
      </p>
      <p style="text-align: justify">
        2.1.1. знакомиться с действующими тарифами на оказываемые Таможенным
        представителем услуги;
      </p>
      <p style="text-align: justify">
        2.1.2. требовать соблюдения конфиденциальности информации,
        представляемой Таможенному представителю;
      </p>
      <p style="text-align: justify">
        2.1.3. требовать оказания услуг в точном соответствии с поданной
        Заявкой, законодательством Таможенного союза и (или) Республики
        Казахстан.
      </p>
      <p>
        <strong> 2.2. Заказчик обязан: </strong>
      </p>
      <p style="text-align: justify">
        2.2.1. определить и сообщить Таможенному представителю таможенную
        процедуру, под которую необходимо поместить груз/товар, подлежащий
        таможенному контролю и таможенной очистке;
      </p>
      <p style="text-align: justify">
        2.2.2. при необходимости, выдать Таможенному представителю доверенность
        на право получения документов и грузов, приходящих в адрес получателя на
        СВХ, а также иные пункты поступления грузов;
      </p>
      <p style="text-align: justify">
        2.2.3. предоставить Таможенному представителю необходимые документы и
        информацию, требуемые для оказания услуг, в соответствии с
        законодательством Таможенного союза и (или) Республики Казахстан;
      </p>
      <p style="text-align: justify">
        2.2.4. оплатить услуги Таможенного представителя в полном объеме в
        течение 3 (трех) рабочих дней с даты предоставления Заказчику счета на
        оплату;
      </p>
      <p style="text-align: justify">
        2.2.5. в случае неисполнения или ненадлежащего исполнения Заказчиком
        своих платежных обязанностей по настоящему Договору, последний обязуется
        оплатить, помимо основной суммы долга, также неустойку в размере
        {{ doc.bc_penalty_amount }} процентов от стоимости услуг по настоящему
        Договору за каждый просроченный день оплаты, при этом максимальный
        размер неустойки не должен превышать общей стоимости оказываемых услуг;
      </p>
      <p style="text-align: justify">
        2.2.6. осуществлять оплату дополнительных расходов Таможенного
        представителя, предусмотренных дополнительным соглашением Сторон, либо
        вызванных изменением ставок таможенных платежей и налогов;
      </p>
      <p style="text-align: justify">
        2.2.7. нести ответственность и возмещать убытки, причиненныеТаможенному
        представителю в результате неисполнения требований Таможенного
        представителя и требований законодательства Таможенного союза и (или)
        Республики Казахстан, а также вызванных предоставлением недостоверной,
        ненадлежащей, неполной документации/информации;
      </p>
      <p style="text-align: justify">
        2.2.8.произвести своевременную оплату всех таможенных платежей и налогов
        согласно законодательству Таможенного союза и (или) Республики
        Казахстан.
      </p>
      <p>
        <strong> 2.3. Таможенный представитель вправе: </strong>
      </p>
      <p style="text-align: justify">
        2.3.1. требовать от Заказчика предоставления информации о таможенной
        (-ых) процедуре (-ах), под которую (-ые) помещается груз/товар,
        подлежащий таможенному контролю и таможенной очистке;
      </p>
      <p style="text-align: justify">
        2.3.2. при необходимости, требовать выдачи Таможенному представителю
        доверенности на право совершения действий от имени Заказчика, право
        получения документов и др.;
      </p>
      <p style="text-align: justify">
        2.3.3. требовать от Заказчика документы и сведения, необходимые для
        таможенных целей, в том числе содержащие конфиденциальную информацию, и
        получать такие документы и сведения в сроки, обеспечивающие соблюдение
        требований, установленных законодательством Таможенного союза и (или)
        Республики Казахстан;
      </p>
      <p style="text-align: justify">
        2.3.4. требовать от Заказчика своевременной оплаты услуг Таможенного
        представителя, на основаниях и в сроки, предусмотренные настоящим
        Договором, с правом применения условий п.2.2.5 настоящего Договора;
      </p>
      <p style="text-align: justify">
        2.3.5. увеличить сроки оказания услуг в связи с не предоставлением
        Заказчиком, либо предоставлением им в неполном объеме документов и
        информации, требуемых в соответствии с законодательством Таможенного
        союза и (или) Республики Казахстан;
      </p>
      <p style="text-align: justify">
        2.3.6. Таможенный представитель вправе отказать в принятии Заявки к
        исполнению в случаях: - не предоставления Заказчиком необходимых
        документов и информации, необходимой для осуществления таможенного
        декларирования; - при наличии задолженности Заказчика перед Таможенным
        представителем, за ранее оказанные услуги; - а также в иных случаях,
        предусмотренных законодательством Республики Казахстан;
      </p>
      <p style="text-align: justify">
        2.3.7. Таможенный представитель обладает иными правами, предусмотренными
        законодательством Таможенного союза и (или) Республики Казахстан, в том
        числе правом залога (удержания) документов на груз Заказчика, в случае
        нарушения последним своих платежных обязательств по настоящему Договору
        перед Таможенным представителем.
      </p>
      <p>
        <strong> 2.4. Таможенный представитель обязан: </strong>
      </p>
      <p style="text-align: justify">
        2.4.1. в процессе согласования Заявки, ознакомить Заказчика с
        действующими тарифами на оказываемые услуги;
      </p>
      <p style="text-align: justify">
        2.4.2. принять Заявку к исполнению, за исключением случаев указанных в
        п.2.3.6. настоящего Договора;
      </p>
      <p style="text-align: justify">
        2.4.3. оказать услуги в соответствии с поданной Заявкой и действующим
        законодательством Таможенного союза и (или) Республики Казахстан;
      </p>
      <p style="text-align: justify">
        2.4.4. руководствоваться в своей деятельности законодательством
        Таможенного союза и (или) Республики Казахстан;
      </p>
      <p style="text-align: justify">
        2.4.5. полученная от Заказчика информация, в том числе конфиденциальная,
        не должна разглашаться или использоваться Таможенным представителем и
        его работниками для собственных целей, передаваться иным лицам, за
        исключением случаев, предусмотренных законодательством Республики
        Казахстан.
      </p>
      <p style="text-align: justify">
        2.5. В обязанности Таможенного представителя не входит совершение
        таможенных операций, связанных с соблюдением требований и условий
        заявленных таможенных процедур, а также иных обязанностей, которые в
        соответствии с законодательством Таможенного союза и (или) Республики
        Казахстан возлагаются только на представляемых ими лиц.
      </p>
      <p class="subtitle">3. Стоимость услуг и порядок взаиморасчетов</p>
      <p style="text-align: justify">
        3.1. Стоимость услуг Таможенного представителя по конкретной Заявке
        рассчитывается согласно перечню оказываемых Заказчику услуг на основании
        Прейскуранта стоимости услуг Таможенного представителя, либо отдельно
        согласовывается Сторонами в конкретной Заявке;
      </p>
      <p style="text-align: justify">
        3.2. Оплата услуг производится в полном объеме не позднее 3 (трех)
        рабочих дней с момента предоставления Заказчику счета;
      </p>
      <p style="text-align: justify">
        3.3. По факту окончания оказания услуг, Таможенный представитель
        подготавливает Акт приемки оказанных услуг, и в последующем передает его
        Заказчику;
      </p>
      <p style="text-align: justify">
        3.4. Акт приемки оказанных услуг подлежит рассмотрению и подписанию
        Заказчиком в течение 3 (трех) рабочих дней с даты его получения.
      </p>
      <p style="text-align: justify">
        3.5. Все возражения против положений, указанных в Акте приемки оказанных
        услуг, должны быть указаны в этом Акте, либо в претензии по данному
        Акту. Отказ от подписания Акта приемки оказанных услуг, в течение срока
        предусмотренного п. 3.4. настоящего Договора, удостоверенного надлежащим
        образом, является основанием для признания его действительным на
        изложенных в нем условиях.
      </p>
      <p style="text-align: justify">
        3.6. Все расчеты между Сторонами производятся в {{ doc.bc_city }}, при
        этом каждая из Сторон самостоятельно несет расходы по своим банковским
        операциям.
      </p>
      <p class="subtitle">4. Процедура урегулирования споров</p>
      <p>
        4.1. В случае возникновения споров по вопросам, предусмотренным
        настоящим Договором или в связи с ним, Стороны примут все меры к их
        разрешению путём переговоров. В случае невозможности разрешения
        указанных споров путём переговоров они подлежат окончательному
        урегулированию в судебном порядке, в соответствии с законодательством
        Таможенного союза или Республики Казахстан, а также международными
        соглашениями, ратифицированными Республикой Казахстан.
      </p>
      <p style="text-align: justify">
        4.2. Местом проведения судебного разбирательства будет являться город
        {{ doc.bc_trial_city }}, языком судебного разбирательства будет являться
        {{ doc.bc_trial_language }}язык.
      </p>
      <p style="text-align: justify">
        4.3. Положения настоящего Договора регулируются законодательством
        Республики Казахстан.
      </p>
      <p class="subtitle">5. Форс-мажор</p>
      <p style="text-align: justify">
        5.1. Стороны освобождаются от ответственности за частичное или полное
        неисполнение обязательств по договору, если такое неисполнение вызвано
        обстоятельствами непреодолимой силы (форс-мажор), включая, но не
        ограничиваясь: военные действия, стихийные бедствия, забастовки,
        массовые беспорядки, погодные условия, шторм, запретительные или
        ограничительные законодательные акты, решения государственных органов,
        наступившие после подписания настоящего Договора и препятствующие
        полному или частичному исполнению каких-либо обязательств по настоящему
        Договору.
      </p>
      <p style="text-align: justify">
        5.2. Срок исполнения обязательств продлевается на время действия таких
        обстоятельств. При этом такие обстоятельства должны быть подтверждены
        уполномоченным органом.
      </p>
      <p style="text-align: justify">
        5.3. О любом из таких обстоятельств Сторона, в отношении которой такие
        обстоятельства наступили, должна уведомить об этом другую Сторону не
        позже 5 (пяти) рабочих дней с момента, как ей стало об этом известно. В
        противном случае такие обстоятельства признаются не наступившими.
      </p>
      <p style="text-align: justify">
        5.4. Если невозможность полного или частичного исполнения обязательств
        Сторонами будет существовать свыше 1 (одного) месяца, то Стороны имеют
        право расторгнуть настоящий Договор и произвести соответствующие
        взаиморасчеты за фактически оказанные услуги.
      </p>
      <p class="subtitle">6. Срок действия настоящего Договора</p>
      <p style="text-align: justify">
        6.1. Настоящий Договор вступает в силу, с момента его подписания и
        действует до полного исполнения Сторонами своих обязательств по нему.
      </p>
      <p>
        6.2. Расторжение настоящего Договора может произойти как по
        добровольному согласию Сторон, так и в одностороннем порядке,
        предусмотренном законодательством Республики Казахстан.
      </p>
      <p style="text-align: justify">
        6.3. Сторона, желающая расторгнуть настоящий Договор, должна
        предоставить письменное уведомление другой Стороне за 10 (десять)
        рабочих дней до предполагаемой даты расторжения. При этом Стороны до
        момента расторжения настоящего Договора должны исполнить уже ранее
        принятые на себя по настоящему Договору обязательства.
      </p>
      <p style="text-align: justify">
        6.4. Оферта по расторжению настоящего Договора должна быть рассмотрена
        другой Стороной в течение 10 (десять) рабочих дней с даты ее получения.
      </p>
      <p style="text-align: justify">
        6.5. При прекращении действия настоящего Договора по любой причине
        Стороны обязаны в течение 10 (десять) рабочих дней срок произвести
        полный взаимный расчет на основании Акта окончательной сверки. В случае
        получения после прекращения настоящего Договора дополнительных
        документов о наличии неисполненных обязательств (задолженности) одной из
        Сторон, образовавшихся в период действия настоящего Договора,
        Сторона-должник обязана погасить такую задолженность на условиях
        настоящего Договора.
      </p>
      <p class="subtitle">7. Прочие условия</p>
      <p style="text-align: justify">
        7.1. Таможенный представитель не несет ответственность за неоплату, либо
        несвоевременную оплату Заказчиком всех обязательных государственных
        сборов, платежей и пошлин, предусмотренных законодательством Таможенного
        союза и (или) Республики Казахстан.
      </p>
      <p style="text-align: justify">
        7.2. Таможенный представитель не несет ответственность за неверное
        таможенное декларирование и его последствия, вызванные предоставлением
        недостоверной, неполной, ненадлежащей информации и документации со
        стороны Заказчика.
      </p>
      <p style="text-align: justify">
        7.3. Заказчик несет ответственность, предусмотренную законодательством
        Таможенного союза и (или) Республики Казахстан, за своевременность и
        достоверность сведений и документов, предоставленных Таможенному
        представителю для заполнения бланков таможенных документов и определения
        кода ТНВЭД, а также за соответствие представленных сведений фактической
        номенклатуре грузов, предъявленных к таможенному досмотру, и возмещает
        Таможенному представителю связанные с этим фактические убытки.
      </p>
      <p style="text-align: justify">
        7.4. По завершению таможенных операций Таможенный представитель не несет
        никаких обязательств, связанных с завершением таможенных процедур.
      </p>
      <p style="text-align: justify">
        7.5. Настоящий Договор, запросы, заявки, уведомления, подписанные
        Сторонами и переданные по факсу либо в отсканированном виде по
        электронной почте, считаются действительными при наличии оригинальной
        печати и подписи одной из Сторон, и принимаются Сторонами к исполнению.
      </p>
      <p style="text-align: justify">
        7.6. Настоящий Договор составлен в 2 (двух) подлинных экземплярах, на
        русском языке, имеющих одинаковую юридическую силу, по одному для каждой
        из Сторон.
      </p>
      <p style="text-align: justify">
        7.7. Все изменения и дополнения к настоящему Договору действительны лишь
        в том случае, если они совершены в письменной форме и подписаны
        уполномоченными представителями Сторон.
      </p>
      <p style="text-align: justify">
        7.8. Все вопросы, не урегулированные настоящим Договором,
        регламентируются законодательством Таможенного союза и (или) Республики
        Казахстан.
      </p>
      <p class="subtitle">
        8. Юридические адреса и банковские реквизиты Сторон
      </p>
      <div class="table" style="">
        <table
          border="1"
          cellpadding="10"
          cellspacing="0"
          width="100%"
          style="border-style: solid"
        >
          <tr>
            <td>
              <strong>Таможенный представитель:</strong><br />
              {{ doc.org2.organizations.org_name }},<br />
              {{ doc.org2.org_residency.display_text }}<br />
              {{ doc.org2.organizations.post_address }}<br />
              {{ doc.org2.organizations.company_ceo }}
            </td>
            <td>
              <strong>Заказчик:</strong><br />
              {{ doc.org1.organizations.org_name }},<br />
              {{ doc.org1.org_residency.display_text }}<br />
              {{ doc.org1.organizations.post_address }}<br />
              {{ doc.org1.organizations.company_ceo }}
            </td>
          </tr>
        </table>
      </div>
    </div>
    <canvas id="signature_canvas"></canvas>
  </div>
</template>
<script>
import moment from "moment";
import "moment/locale/ru";
var QRCode = require("qrcode");
export default {
  name: "broker_contract",
  props: ["user_id", "doc_id", "doc", "goods", "doc_additional"],
  data() {
    return {};
  },
  mounted() {
    // moment.locale(this.i18n.locale=='cn'?'zh-cn':'ru', this.i18n.locale=='cn'?zh:ru);
    moment.locale("ru");
    axios
      .get(
        window.base +
          "/contract/LoadBrokerContractSignature?contract_id=" +
          this.doc_id,
      )
      .then((response) => {
        if (typeof response.data.signature !== "undefined") {
          // console.log("as")
          if (response.data.signature == "") {
            this.$root.$emit("print-pdf", {
              signature: "",
              type: "broker_contract",
            });
            new Noty({
              theme: "light",
              type: "error",
              text: this.$t("message.contracts.no-signature-message"),
              timeout: 5000,
            }).show();
          } else {
            var canvas = QRCode.toCanvas(response.data.signature, {
              width: 100,
              height: 100,
            });
            canvas.then((r) => {
              // this.check_signature(value, ()=>{
              this.$root.$emit("print-pdf", {
                signature: r,
                type: "broker_contract",
              });
              new Noty({
                theme: "light",
                type: "success",
                text: this.$t("message.contracts.yes-signature-message"),
                timeout: 5000,
              }).show();
              // window.webSocket.removeEventListener('message', {})
              // })
            });
          }
        } else {
          // console.log("bs")
          this.$root.$emit("print-pdf", {
            signature: "",
            type: "broker_contract",
          });
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.contracts.no-signature-message"),
            timeout: 5000,
          }).show();
        }
      });
  },
  methods: {
    /**
     * proxy to call external function in template
     */
    number_to_letters(val) {
      if (this.$i18n.locale == "en") return window.number_to_letters_en(val);
      else return window.number_to_letters(val);
    },
    /**
     * proxy to call external function in template
     */
    days_to_letters(val) {
      if (this.$i18n.locale == "en") return window.days_to_letters_en(val);
      else return window.days_to_letters(val);
    },
    /**
     * proxy to call external function in template
     */
    money_letters(val, cur) {
      if (this.$i18n.locale == "en") return window.money_letters_en(val, cur);
      else return window.money_letters(val, cur);
    },
    /**
     * proxy to call external function in template
     */
    percent_to_letters(val) {
      if (this.$i18n.locale == "en") return window.percent_to_letters_en(val);
      else return window.percent_to_letters(val);
    },
    /**
     * Checks if newly generated signature is similar to the one previously saved on the server.
     * If got true – everything ok, can download file, if false – then the document
     * has not been signed yet or has been changed after signing.
     */
    check_signature(signature, callback) {
      var fd = new FormData();
      fd.append("contract_id", this.doc_id);
      fd.append("signature", signature);
      axios
        .post(window.base + "/contract/CheckBrokerContractSignature", fd)
        .then((r) => {
          if (r.data == "False") {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$root.$t(
                "message.message.document_signature_is_wrong",
              ),
              timeout: 5000,
            }).show();
          } else {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.document_signature_is_ok"),
              timeout: 5000,
            }).show();
            callback();
          }
        });
    },
    callback(r) {
      if (r.code == "200") {
        var oParser = new DOMParser();
        var oDOM = oParser.parseFromString(
          r.getResponseObject(),
          "application/xml",
        );
        var value = oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
        var canvas = QRCode.toCanvas(value, { width: 100, height: 100 });
        canvas.then((r) => {
          this.check_signature(value, () => {
            this.$root.$emit("print-pdf", { signature: r, type: "contract" });
            window.webSocket.removeEventListener("message", {});
          });
        });
      }
    },
    getOrganizationAddress(org) {
      if (org.addresses[0] != null)
        return (
          org.org_residency.display_text +
          ", " +
          org.addresses[0].post_addr_district +
          ", " +
          org.addresses[0].post_addr_streethouse +
          " " +
          org.addresses[0].post_addr_house
        );
      return "";
    },
  },
  watch: {},
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    contract_currency() {
      return this.doc.attis_contract_currency.display_text;
    },
    contract_currency_code() {
      return this.doc.attis_contract_currency.value;
    },
    delivery_terms() {
      return (
        '"' +
        this.doc.attis_contract_delivery_term.value +
        ": " +
        this.doc.attis_contract_delivery_term.display_text +
        '"'
      );
    },
    day() {
      return moment(this.doc.bc_date).format("D");
    },
    month() {
      return moment(this.doc.bc_date).format("MMMM");
    },
    year() {
      return moment(this.doc.bc_date).format("Y");
    },
    date() {
      return moment().format("D.MM.Y");
    },
    document_date() {
      // this.doc.attis_contract_create_date
    },
    currency() {
      var c = "";
      if (typeof this.invoice.CurrencyCode !== "undefined")
        this.currencies.forEach((item) => {
          if (item.value == this.invoice.CurrencyCode.trim()) {
            c = item.display_text;
          }
        });
      return c;
    },
  },
};
</script>
<style scoped>
.title {
  font-weight: bold;
  text-align: center;
  text-decoration: underline;
  font-size: 1.2em;
}
.subline {
  display: flex;
  justify-content: space-between;
  margin: 30px 0;
}
.subtitle {
  text-align: center;
  font-weight: bold;
}
</style>
